import { PaletteOptions } from '@mui/material';

interface CustomPalette {
  primary: {
    states: {
      hover: string;
      selected: string;
    };
  };
  secondary: {
    states: {
      selected: string;
    };
  };
  icon: {
    primary: string;
    secondary: string;
    disabled: string;
  };
  // Старые
  divider: string;
  greyDark: string;
  red: string;
  darkRed: string;
  dropShadow: string;
  bg1: string;
  slot: string;
  avatarFill: string;
  grey100: string;
  grey200: string;
  amber300: string;
  primarySelected: string;
  secondaryHover: string;
  secondaryFocus: string;
  text: {
    disabled: string;
  };
  mascot: string;
}

// @ts-ignore
export interface IPaletteOptions extends PaletteOptions {
  custom: CustomPalette;
}

// TODO Актуализировать
// Использовать только в теме MUI
export const palette: IPaletteOptions = {
  background: {
    default: '#ffffff',
    paper: '#ffffff',
  },
  primary: {
    light: '#7FC797',
    main: '#009030',
    dark: '#105525',
    contrastText: '#ffffff',
  },
  secondary: {
    light: '#CADFEC',
    main: '#669DBD',
    dark: '#156492',
    contrastText: '#ffffff',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.60)',
    disabled: '#9e9e9e',
  },
  error: {
    main: '#d32f2f',
    dark: '#c62828',
    light: '#ef5350',
  },
  success: {
    main: '#2e7d32',
    dark: '#1b5e20',
    light: '#4caf50',
  },
  warning: {
    main: '#ed6c02',
    dark: '#e65100',
    light: '#ff9800',
  },
  info: {
    main: '#0288d1',
    dark: '#01579b',
    light: '#03a9f4',
  },
  action: {
    active: '#707070',
    hover: '#f5f5f5',
    selected: '#ebebeb',
    disabledBackground: '#e0e0e0',
    focus: '#e0e0e0',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  custom: {
    primary: {
      states: {
        hover: 'rgba(34, 120, 61, 0.08)',
        selected: 'rgba(0, 144, 48, 0.12)',
      },
    },
    secondary: {
      states: {
        selected: 'rgba(0, 95, 149, 0.08)',
      },
    },
    icon: {
      primary: '#040404', // 87%
      secondary: '#757575', // 60%
      disabled: '#A4A4A4', // 38%
    },
    // Старые
    divider: '#e0e0e0',
    greyDark: '#858585',
    red: '#FF4526',
    darkRed: '#E40000',
    dropShadow: 'rgba(0, 0, 0, 0.25)',
    bg1: '#fafafa',
    slot: '#F6F6FB',
    avatarFill: '#BDBDBD',
    grey100: '#F5F5F5',
    grey200: '#EEEEEE',
    amber300: '#FFD54F',
    primarySelected: 'rgba(0, 144, 48, 0.12)',
    secondaryHover: '#005F9514',
    secondaryFocus: '#005F9533',
    text: {
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
    mascot: '#66BC83',
  },
};
